/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_ConvertedInputs */

const cs_reports_col_converted = /** @type {(inputs: Reports_Col_ConvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konvertováno`)
};

const en_reports_col_converted = /** @type {(inputs: Reports_Col_ConvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converted`)
};

/**
* | output |
* | --- |
* | "Converted" |
*
* @param {Reports_Col_ConvertedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_col_converted = /** @type {((inputs?: Reports_Col_ConvertedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_ConvertedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_converted(inputs)
	return cs_reports_col_converted(inputs)
});